import React from 'react'
import { Link } from "react-router-dom";
import {  Badge } from "antd";
import {useProjectForm} from "../../../providers/ProjectFormProvider";


const ReviewProjectScope = ({linkParams = '', className = '',...props}) => {

    const {project} = useProjectForm();

    if (!project) return null;

    const desiredDisciplineIds = TB.map(
        TB.uniqBy(TB.flatMap(
            TB.flatMap(project.phases, 'deliverables'), del => {
                if (del.is_desired === false) {
                    return [];
                }
                return TB.flatMap(del.activities, 'disciplines');
            }), 'id'), 'id');

    const disciplines = TB.orderBy(project.disciplines || [], discipline => {
        return desiredDisciplineIds.includes(discipline.id) ? 1 : 0;
    }, 'desc')
    return (
        <table className={"table mb-[-1px] border-y-0 text-left " + className}>
            <tbody>

            <tr className="bg-transparent review-item">
                <td colSpan={2} className="border-none pt-[28px]">
                    <p className="review-item-title text-gray-500">
                        Project Type:
                    </p>
                    <div className="review-item-section">
                        <div className="review-items-info">
                            <div className="review-item-label">
                                <span className="text-primary font-semibold">
                                    {project.template.name}
                                </span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr className="bg-transparent review-item">
                <td className="p-4 border-none">
                    <p className="review-item-title text-gray-500">
                        Project Phases & Deliverables
                    </p>
                    <div className="flex flex-col items-stretch gap-4">
                        {TB.map(project.phases, phase => (
                            <div key={`phase-${phase.id}`} className="mt-3.5">
                                <p className="review-scope-question-label">
                                    Phase #{phase.display_index + 1}: {phase.name}
                                </p>
                                {TB.map(phase.deliverables, deliverable => {
                                    return (
                                        <p key={`phase-${phase.id}-del-${deliverable.id}`}
                                           className={
                                               TB.mapClass("mt-3.5 text-sm items-center whitespace-nowrap overflow-ellipsis flex flex-row gap-1.5", {
                                                   "font-semibold": deliverable.is_desired,
                                                   "opacity-50": deliverable.is_desired === false
                                               })}>
                                            {deliverable.is_desired === true ? (
                                                <i className="text-sm fas fa-check-circle text-success"/>
                                            ) : (deliverable.is_desired === false ? (
                                                <i className="text-sm fas fa-times-circle text-gray-600"/>
                                            ): (
                                                <i className="text-sm fas fa-question-circle text-gray-600"/>
                                            ))}
                                            <span
                                                className={deliverable.is_desired === false ? "line-through" : undefined}>
                                                {deliverable.name}
                                            </span>
                                        </p>
                                    )
                                })}
                            </div>
                        ))}
                    </div>
                </td>
                <td className="review-scope-question-actions actions-cell border-none">
                    {project.canEditScope() && (
                        <Link to={`/client/project/setup/${project.id}/deliverables` + linkParams} className="btn btn-link">
                            Edit
                        </Link>
                    )}
                </td>
            </tr>
            <tr className="bg-transparent review-item">

                <td className="p-4 border-none">
                    <p className="review-item-title text-gray-500">
                        Roles & Skills
                    </p>
                    <p className="review-scope-question-label mt-3.5">
                        Project Roles
                    </p>
                    {TB.map(disciplines, discipline => {
                        const isSelected = desiredDisciplineIds.includes(discipline.id)
                        return (
                            <p key={`dis-${discipline.id}`}
                               className={TB.mapClass("mt-3.5 text-sm items-center whitespace-nowrap overflow-ellipsis flex flex-row gap-1.5", {
                                   "font-semibold": isSelected,
                                   "opacity-50": !isSelected
                               })}>
                                {isSelected ? (
                                    <i className="text-sm fas fa-check-circle text-success"/>
                                ) : (
                                    <i className="text-sm fas fa-times-circle text-gray-600"/>
                                )}
                                <span className={!isSelected ? "line-through" : undefined}>
                                    {discipline.name}
                                </span>
                            </p>
                        )
                    })}

                    <p className="review-scope-question-label mt-5">
                        Project Skills
                    </p>
                    <div
                        className="my-3 flex flex-row flex-wrap gap-y-2.5 gap-x-2 items-center justify-start">
                        {TB.map(project.skills, skill => (
                            <Badge key={`skill-${skill.id}`}
                                   count={skill.name}
                                   color={TB.config('color.secondary')}/>
                        ))}
                    </div>
                </td>
                <td className="review-scope-question-actions actions-cell border-none">
                    {project.canEditScope() && (
                        <Link to={`/client/project/setup/${project.id}/skills` + linkParams} className="btn btn-link">
                            Edit
                        </Link>
                    )}
                </td>
            </tr>
            <tr className="bg-transparent review-item">

                <td className="p-4 border-none">

                    <p className="review-scope-question-label mt-3.5">
                        Project Industries
                    </p>
                    <div
                        className="my-3 flex flex-row flex-wrap gap-y-2.5 gap-x-2 items-center justify-start">
                        {TB.map(project.industries, industry => (
                            <Badge key={`industry-${industry.id}`}
                                   count={industry.name}
                                   color={TB.config('color.secondary')}/>
                        ))}
                    </div>

                </td>
                <td className="review-scope-question-actions actions-cell border-none">
                    {project.canEditScope() && (
                        <Link to={`/client/project/setup/${project.id}/industries` + linkParams} className="btn btn-link">
                            Edit
                        </Link>
                    )}
                </td>
            </tr>
            </tbody>
        </table>
    )
}

export default ReviewProjectScope;